"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const InternalToExternalEnumMappings_1 = require("../EnumMappings/InternalToExternalEnumMappings");
const ServiceRegistry_1 = require("../Services/ServiceRegistry");
const DataValueFactory_1 = require("../Utils/DataValueFactory");
const ErrorHelpers_1 = require("../Utils/ErrorHelpers");
const Param_1 = require("../Utils/Param");
class ParameterImpl {
    constructor(parameterInfo, _registryId) {
        this._registryId = _registryId;
        this.setParameterInfo(parameterInfo);
    }
    get name() {
        return this._parameterInfo.name;
    }
    get currentValue() {
        return DataValueFactory_1.DataValueFactory.MakeParameterDataValue(this._parameterInfo.currentValue, this._parameterInfo.dataType);
    }
    get dataType() {
        return InternalToExternalEnumMappings_1.InternalToExternalEnumMappings.dataType.convert(this._parameterInfo.dataType);
    }
    get id() {
        return this._globalFieldName;
    }
    get allowableValues() {
        return this._allowableValues;
    }
    changeValueAsync(newValue) {
        ErrorHelpers_1.ErrorHelpers.verifyParameter(newValue, 'newValue');
        const coercedValue = Param_1.Param.serializeParameterValue(newValue);
        const parametersService = ServiceRegistry_1.ApiServiceRegistry.get(this._registryId).getService("parameters-service" /* Parameters */);
        return parametersService.changeParameterValueAsync(this._globalFieldName, coercedValue).then((parameterInfo) => {
            this.setParameterInfo(parameterInfo);
            return this.currentValue;
        });
    }
    setParameterInfo(parameterInfo) {
        this._parameterInfo = parameterInfo;
        this._globalFieldName = parameterInfo.fieldName;
        const type = InternalToExternalEnumMappings_1.InternalToExternalEnumMappings.allowableValues.convert(parameterInfo.allowableValuesType);
        let listValues;
        let minValue;
        let maxValue;
        let stepSize;
        let dateStepPeriod;
        if (type === api_external_contract_js_1.ParameterValueType.List) {
            const values = parameterInfo.allowableValues || [];
            listValues = values.map((val) => DataValueFactory_1.DataValueFactory.MakeParameterDataValue(val, parameterInfo.dataType));
        }
        else if (type === api_external_contract_js_1.ParameterValueType.Range) {
            minValue = parameterInfo.minValue && DataValueFactory_1.DataValueFactory.MakeParameterDataValue(parameterInfo.minValue, parameterInfo.dataType);
            maxValue = parameterInfo.maxValue && DataValueFactory_1.DataValueFactory.MakeParameterDataValue(parameterInfo.maxValue, parameterInfo.dataType);
            stepSize = parameterInfo.stepSize;
            dateStepPeriod = parameterInfo.dateStepPeriod && InternalToExternalEnumMappings_1.InternalToExternalEnumMappings.dateStepPeriod.convert(parameterInfo.dateStepPeriod);
        }
        this._allowableValues = {
            type: type,
            allowableValues: listValues,
            minValue: minValue,
            maxValue: maxValue,
            stepSize: stepSize,
            dateStepPeriod: dateStepPeriod,
        };
    }
}
exports.ParameterImpl = ParameterImpl;
//# sourceMappingURL=ParameterImpl.js.map